import {
  REQUEST_CONNECT_MAP_SIGNALR,
  RESPONSE_CONNECT_MAP_SIGNALR,
  RESPONSE_FAILURE_CONNECT_MAP_SIGNALR,
  REQUEST_START_CONNECTION_MAP_SIGNALR,
  RESPONSE_START_CONNECTION_MAP_SIGNALR,
  REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR,
  REQUEST_STOP_CONNECTION_MAP_SIGNALR,
  REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR,
  RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR,
  REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR,
  RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
} from "../actions/signalRActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataConnectionState: queriesStates.NOT_REQUESTED,
  dataStartConnectionState: queriesStates.NOT_REQUESTED,
  dataUserGroupState: queriesStates.NOT_REQUESTED,
  connection: null,
  error: {}, 
};

const signalRReducer = (state = initialState, action) => {
  switch (action.type) {
  
    case REQUEST_CONNECT_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataConnectionState: queriesStates.REQUEST,
        dataStartConnectionState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_CONNECT_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataConnectionState: queriesStates.READY,
        dataStartConnectionState: queriesStates.READY,
        connection: action.connection,
      });
    }
    case RESPONSE_FAILURE_CONNECT_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataConnectionState: queriesStates.FAILURE,
        dataStartConnectionState: queriesStates.FAILURE,
        error: action.error,
      });
    }
    case REQUEST_START_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataStartConnectionState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_START_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataStartConnectionState: queriesStates.READY,
      });
    }
    case REQUEST_FAILURE_START_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataStartConnectionState: queriesStates.FAILURE,
      });
    }
    case REQUEST_STOP_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataStartConnectionState: queriesStates.NOT_REQUESTED,
        dataUserGroupState: queriesStates.NOT_REQUESTED,
      });
    }
    case REQUEST_ADD_USER_TOGROUP_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataUserGroupState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_ADD_USER_TOGROUP_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataUserGroupState: queriesStates.READY,
      });
    }
    case REQUEST_FAILURE_ADD_USER_TOGROUP_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataUserGroupState: queriesStates.FAILURE,
      });
    }
    case RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        dataConnectionState: queriesStates.FAILURE,
        dataStartConnectionState: queriesStates.FAILURE,
        dataUserGroupState: queriesStates.NOT_REQUESTED,
      });
    }
    default:
      return state;
  }
};

export default signalRReducer;
